import React from 'react';
import Icon from '@pushpay/icon';

const HelpCenterIcon = props => /*#__PURE__*/React.createElement(Icon, Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10-.006-5.52-4.48-9.994-10-10zm0 15.833a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm1.333-5.066a.833.833 0 00-.5.764.834.834 0 01-1.666 0 2.5 2.5 0 011.5-2.292 1.667 1.667 0 10-2.334-1.527.834.834 0 01-1.666 0 3.333 3.333 0 114.666 3.055z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export default HelpCenterIcon;